<template>
  <div class="multi-delay-schedule">
    <div class="main">
      <choosed-nav :len="courseArrangeIds.length" /> 

      <div class="title">修改类型</div>
      <van-field 
        label="" 
        :border="false"
        input-align="left" >
        <template #input>
          <van-radio-group v-model="type">
            <van-radio :name="1">延后上课</van-radio>
            <van-radio :name="2">提前上课</van-radio>
            <van-radio :name="3">修改为同一天</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <van-field 
        style="margin-top:24px" 
        v-model="delayDays" 
        :label="type == 1 ? '延后天数' : '提前天数'" 
        :placeholder="type == 1 ? '请填写延后天数' : '请填写提前天数'" 
        :formatter="numberFormatter"
        :border="false"
        input-align="right"
        v-show="type == 1 || type == 2"/>
      <div class="item-tips" v-if="type == 1">例：某节课10月10日上课，延后3天，则这节课将在10月13日上课。</div>
      <div class="item-tips" v-else-if="type == 2">例：某节课10月10日上课，提前3天，则这节课将在10月7日上课。</div>
      <van-field
        label="修改为"
        readonly
        is-link
        placeholder="请选择"
        input-align="right"
        :border="false"
        @click="chooseDate"
        style="margin-top:24px"
        v-show="type == 3">
        <template #input>
          <div style="color: var(--g8)" v-if="courseDate">{{ courseDate }}</div>
          <div v-else style="color: var(--g5)">请选择</div>
        </template>
      </van-field> 
    </div>
    <div class="footer">
      <van-button square round block type="primary" @click="submitConfirm">保存</van-button>
    </div>
  </div>
</template>

<script>
import choosedNav from './choosed-nav.vue';

export default {
  name: "multiDelaySchedule",
  components:{
    choosedNav,
  },
  data() {
    return {
      pageTitle: "修改上课日期",
      courseArrangeIds: [],
      delayDays: '',
      type: 1,
      checkConflict: true,
      checkConflictScope: 3,
      courseDate: '',
    }
  },
  created () {
    Object.assign(this, app.ls.get("multi-delay-schedule-obj"));
    this.$onBus("multi-edit-course-continue", () => {
      this.checkConflict = false;
      this.submit();      
      this.checkConflict = true;
    });
  },
  methods: {
    submitConfirm () {
      if ((this.type == 1 || this.type == 2) && !this.delayDays && this.delayDays!==0) {
        this.$toast.fail( this.type == 1?'请填写延后天数。':'请填写提前天数。' );
        return false;
      }
      if (this.type == 3 && !this.courseDate) {
        this.$toast.fail( '请选择上课日期。' );
        return false;
      }
      vant.Dialog.confirm({message: '确定保存？', confirmButtonText: '确定'})
        .then(()=>{
          this.submit();
        })
        .catch(err=> {
          console.log('取消了。。')
        })
    },      
    submit() {
      this.showLoading();
      let params = {
        checkConflict: this.checkConflict,
        courseArrangeIds: this.courseArrangeIds,
        type: this.type,
        checkConflictScope: this.checkConflictScope,
      }
      if (this.type == 3) {
        Object.assign(params, {
          courseDate: this.courseDate,
        });
      } else {
        Object.assign(params, {
          days: this.delayDays,
        });
      }
      this.$api.batchDelay(params).then(res=>{
        if (res.code === 200) {
          app.vue.$emit("refresh-multi-edit-page");
          vant.Toast.success( "修改成功");
          setTimeout(()=>{
            this.$router.back();
          }, 300)
        } if (res.code === 830000005) {
          // 临时变量，用于存储排课冲突信息，以便在冲突页面展示
          app.ls.set('multi-edit-course-error', res.data)
          this.$router.push("/multiPaikeErr")
          this.$toast.clear()
        }
      })
    },
    numberFormatter (v) {
      let newV = v>=0 && v!=='' ? Math.floor(v.replace(/[^0-9]+/g, '')) : '';
      return newV > 366 ? 366 : newV === 0 ? 1 : newV;
    },
    continueModify () {
      let errs = app.ls.get("multi-edit-course-error");      
      // 冲突类型1表示选择的排课内校验冲突
      // 用户选择忽略，需要继续校验成系统其它排课有无冲突
      this.checkConflict = errs.conflictType === 1 ? true : false;
      errs.conflictType === 1 && (this.checkConflictScope = 2); 
      this.submit();      
      this.checkConflict = true;
      this.checkConflictScope === 3;
    },
    async chooseDate() {
      let res = await app.x3.picker.calendar({
        defaultDate: this.courseDate ? new Date(this.courseDate) : new Date(),
        minDate: new Date(2020, 1, 1),
      });
      this.courseDate = app.tool.date.formatDatetime(res.getTime(), 'yyyy-MM-dd');
    }
  },
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
.multi-delay-schedule {
  display: flex;
  flex-direction: column;
  .main {
    flex: 1;
    overflow-y: auto;
    .title {
      margin-top: calc(var(--gap) * 24);
      padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
      background-color: var(--white);
    }
    .van-radio {
      padding: calc(var(--gap) * 16) 0;
      &:first-child {
        padding-top: 0;
      }
      &:last-child {
        padding-bottom: 0;
      }
    }
    .item-tips {
      height: 44px;
      padding:16px;
      color: var(--g6);
    }
  }
  .footer {
    height: 50px;
    background: var(--white);
    padding: 5px 16px;
    display: flex;
    .van-button {
      height: 40px;
    }
  }
}
</style>